export type FieldType = 'text' | 'number' | 'date' | 'enum' | 'boolean' | 'lookup';

export type Operator =
    | 'eq' | 'neq' | 'contains' | 'starts_with' | 'ends_with'
    | 'gt' | 'lt' | 'gte' | 'lte' | 'between'
    | 'before' | 'after' | 'between_dates'
    | 'in' | 'not_in'
    | 'is_true' | 'is_false'
    | 'in_lookup';

export const operatorLabels: Record<Operator, string> = {
    eq: 'igual a',
    neq: 'diferente de',
    contains: 'contém',
    starts_with: 'começa com',
    ends_with: 'termina com',
    gt: 'maior que',
    lt: 'menor que',
    gte: 'maior ou igual',
    lte: 'menor ou igual',
    between: 'entre',
    before: 'antes de',
    after: 'depois de',
    between_dates: 'entre datas',
    in: 'é um de',
    not_in: 'não é',
    is_true: 'sim',
    is_false: 'não',
    in_lookup: 'pertence a',
};

export const operatorsByType: Record<FieldType, Operator[]> = {
    text: ['eq', 'neq', 'contains', 'starts_with', 'ends_with'],
    number: ['eq', 'neq', 'gt', 'lt', 'gte', 'lte', 'between'],
    date: ['before', 'after', 'between_dates'],
    enum: ['in', 'not_in'],
    boolean: ['is_true', 'is_false'],
    lookup: ['in_lookup'],
};

export interface FilterOption {
    value: string;
    label: string;
}

export interface LookupConfig {
    endpoint: string;
    searchField: string;
    displayField: string;
    valueField: string;
    schema?: FilterSchema[];
}

export interface FilterSchema {
    key: string;
    label: string;
    type: FieldType;
    operators: Operator[];
    defaultOperator: Operator;
    visible: boolean;
    options?: FilterOption[];
    lookupConfig?: LookupConfig;
}

export interface AppliedFilter {
    id: string;
    key: string;
    label: string;
    type: FieldType;
    operator: Operator;
    value: any;
}

export interface FilterHistory {
    filters: AppliedFilter[];
    timestamp: number;
}
